import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Card, CardContent, Typography, Grid, Hidden } from "@material-ui/core";
import { useMediaQuery } from "react-responsive";
import SearchedFaqs from "./_searched-faqs";
import SearchedAnnouncements from "./_searched-announcements";
import SearchedLinks from "./_searched-links";
import SearchedUserguides from "./_searched-userguide";
import SearchedTariff from "./_searched-tarrif";
import { useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  noResultsGrid: {
    height: "50vh",
    width: "100%",
  },
  noResutls: {
    color: "lightgrey",
  },
  textStyles:{
    color: theme.palette.eTertiary.base ,
  },
  exclaimation: {
    backgroundColor: theme.palette.eTertiary.base ,
    height: "35px",
    width: "35px",
    borderRadius: "50%",
    color: "white",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
}));

export default function SearchContent(props) {
  const classes = useStyles();
  const labels = useSelector((state) => state?.labels?.data?.getLabels?.SEARCH);

  const [searchResult, setSearchResult] = useState({});
  const [loading, setLoading] = useState(true);

  const [searchFaqs, setsearchFaqs] = useState([]);
  const [searchAnn, setsearchAnn] = useState([]);
  const [searchLinks, setsearchLinks] = useState([]);
  const [searchTariff, setsearchTariff] = useState([]);
  const [searchUserguide, setsearchUserguide] = useState([]);

  useEffect(() => {
    setSearchResult(props.searchResults);
    setsearchFaqs(
      props.searchResults?.hits?.hits?.filter(
        (item) => item?._source?.ContentCategoryCode === "FAQ_AUTH"
      )
    );
    setsearchAnn(
      props.searchResults?.hits?.hits?.filter(
        (item) => item?._source?.ContentCategoryCode === "ANNOUNCEMENT_AUTH"
      )
    );
    setsearchLinks(
      props.searchResults?.hits?.hits?.filter(
        (item) => item?._source?.ContentCategoryCode === "LINKS_AUTH"
      )
    );
    setsearchTariff(
      props.searchResults?.hits?.hits?.filter(
        (item) => item?._source?.ContentCategoryCode === "TARIFF_AUTH"
      )
    );
    setsearchUserguide(
      props.searchResults?.hits?.hits?.filter(
        (item) => item?._source?.ContentCategoryCode === "USER_GUIDE_AUTH"
      )
    );
    if (props.searchResults) {
      setLoading(false);
    }
  }, [props.searchResults]);

  return (
    <Grid container>
      {searchResult?.hits?.total?.value ? (
        <React.Fragment>
          <Grid container spacing={3}>
          {searchFaqs.length ? (
              <Grid xs={12} item>
                <SearchedFaqs searchResult={searchFaqs} />
              </Grid>
            ) : null}

            {searchUserguide.length ? (
              <Grid xs={12} item>
                <SearchedUserguides searchResult={searchUserguide} />
              </Grid>
            ) : null}

            {searchLinks.length ? (
              <Grid xs={12} item>
                <SearchedLinks searchResult={searchLinks} />
              </Grid>
            ) : null}

            {searchAnn.length ? (
              <Grid xs={12} item>
                <SearchedAnnouncements searchResult={searchAnn} />
              </Grid>
            ) : null}


            {searchTariff.length ? (
              <Grid xs={12} item>
                <SearchedTariff searchResult={searchTariff} />
              </Grid>
            ) : null}
          </Grid>
        </React.Fragment>
      ) : props.sloading ? null : (
        <Grid
          container
          justify="center"
          alignItems="center"
          alignContent="center"
          className={classes.noResultsGrid}
        >
          <Grid
            direction="column"
            container
            alignItems="center"
            alignContent="center"
            justify="center"
            item
          >
            <Grid item className={classes.exclaimation}>
              <div>
                <span style={{ fontSize: "2rem" }}>!</span>
              </div>
            </Grid>
            <Grid item>
              {" "}
              <Typography className={classes.textStyles} variant="h5" component="h6" align="center">
                {labels?.SEARCH_NO_RESULTS_FOUND}
              </Typography>{" "}
            </Grid>
          </Grid>
        </Grid>
      )}
    </Grid>
  );
}
